(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE={id:"mosty@0.39.7"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sentry/webpack-plugin/src/sentry-webpack.module.js
// module id = 275
// module chunks = 0